import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Footer from '../containers/Footer';
import hero from '../assets/hero.jpg'

const Wrapper = styled.div`
  height: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 36px;
  margin-top: 50px;
  padding-bottom: 100px;

  @media (orientation: portrait) and (max-width: 767px) {
    margin-top: 20px;
  }
`;

const TopLineWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const TopLineTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

`;

const TopLineTitle = styled.h2`
  font-size: 26px;
  line-height: auto;
  color: ${({ theme }) => theme.colors.basic1000};
  margin: 0;
  margin-bottom: 5px;
  font-weight: 700;
  padding-top:20px;
  text-align: center;

`;

const TopLineSubtitle = styled.h3`
  font-size: 20px;
  line-height: auto;
  color: ${({ theme }) => theme.colors.basic1000};
  font-weight: 300;
  margin: 0;
`;


const MainTitle = styled.h1`
  font-size: 20px;
  color: #000000;
  font-weight: 400;
  margin: 8px 0;
  padding-bottom:10px;
`;

const Disclaimer = styled.p`
  margin-top: 30px;
  font-size: 11px;
  line-height: 15px;
  color: ${({ theme }) => theme.colors.basic1000};
  font-weight: 300;
  text-align: justify;
`;

const Home = () => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

const Text = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  padding-bottom:20px;
  font-weight: 300;
  text-align: center;
  color: ${({ theme }) => theme.colors.basic2000};
`;
const WrappedLink = styled(Link)`
  margin: 10px 0;
`;

const InnerLink = styled.span`
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin: 10px 0;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.3s ease-out;

  :hover {
    color: #3fff00;
  }
`;

  return (
    <Wrapper>
      <TopLineWrapper>
        <TopLineTextWrapper>
          <TopLineTitle>Te presto más rápido y 100% online</TopLineTitle>
          <TopLineSubtitle>¡Te depositamos en el día!</TopLineSubtitle>
        </TopLineTextWrapper>
      </TopLineWrapper>
      <MainTitle>Pedinos el xtra que necesitás.</MainTitle>
      <div>
        <img style={{ width:'100%', borderRadius:'20px', marginBottom:'20px' }} src={hero} alt="Prextix" />
      </div>
      <Text>Prester es una fintech que promueve la inclusión financiera en la Argentina. Ofrece préstamos inclusivos y 100% digitales a través del celular. Prester responde a la necesidad de millones de argentinos que buscan acceder a servicios financieros de calidad de manera ágil, segura y desde donde quiera que estén. La tecnología de Prester llegó para ampliar el acceso al crédito brindando una solución a medida, en menos de 24hs.
      </Text>

      <WrappedLink to="/" style={{ textDecoration: 'none', width: '80%', textAlign: 'center', background: '#fff000', padding: '15px', borderRadius: '10px'}}><InnerLink style={{ color: "black" }}>Buscar préstamos</InnerLink></WrappedLink>
      <Disclaimer>
      El período mínimo para la devolución de un préstamo es de 3 meses y el máximo es de 36 meses. Todos los préstamos son a tasa fija, en pesos y otorgados bajo el sistema de amortización francés con cuotas mensuales y consecutivas. La aprobación definitiva del préstamo está sujeta al cumplimiento de los requisitos solicitados por Corvalán 1160 S.A. Ejemplo: Monto solicitado de $20.000 a 12 meses | TNA (sin IVA): 150% - TEA (sin IVA): 311,44% - CFTNA (con IVA): 181,50% - CFTEA (con IVA): 442,05%* | Cuota: $3.648 | Total a pagar: $43.776. Este ejemplo no constituye una obligación de Corvalán 1160 S.A. de ofrecer dicha tasa ya que la Tasa Nominal Anual (TNA), la Tasa Efectiva Anual (TEA) y el Costo Financiero Total (CFT) de un préstamo varían dependiendo del perfil crediticio del solicitante. En todos los casos, la TNA, TEA y el CFT aplicable serán informados antes de la aceptación de la oferta de préstamo por parte del solicitante. La TNA mínima es de 150% y la máxima de 299%. A su vez, la TEA mínima es de 311,44% y la máxima de 1.349,07%. CFTEA con IVA: Mínimo: 442,05% - Máximo 2.262,09% CFTEA(*): 2.262,09% (*)IVA incluido      </Disclaimer>
      <Footer />
    </Wrapper>
  );
};

export default Home;
